<!-- Filter Dropdown Button -->
<div class="filter-dropdown-container">
  <button
    mat-raised-button
    [matMenuTriggerFor]="filterMenu"
    class="filter-button"
  >
    <mat-icon>filter_list</mat-icon>
    Filters
  </button>

  <mat-menu #filterMenu="matMenu" class="filter-menu">
    <div class="filter-content" (click)="$event.stopPropagation()">
      <ng-container *ngTemplateOutlet="filters"></ng-container>
    </div>
  </mat-menu>
</div>

<!-- Filter Template -->
<ng-template #filters>
  <div class="filter-sections">
    <!-- Sale & Clearance Section -->
    <mat-expansion-panel class="filter-panel">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <mat-icon>local_offer</mat-icon>
          Special Offers
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="filter-options">
        <div class="filter-option">
          <mat-checkbox
            [(ngModel)]="selectedOnSale"
            (change)="onFilterChange()"
          >
            Sale <span class="filter-count">({{ getOnSaleCount() }})</span>
          </mat-checkbox>
        </div>
        <div class="filter-option">
          <mat-checkbox
            [(ngModel)]="selectedIsClearance"
            (change)="onFilterChange()"
          >
            Clearance <span class="filter-count">({{ getClearanceCount() }})</span>
          </mat-checkbox>
        </div>
      </div>
    </mat-expansion-panel>

    <!-- Product Type Section -->
    <mat-expansion-panel class="filter-panel">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <mat-icon>shopping_bag</mat-icon>
          Product Type
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="filter-options">
        <div *ngFor="let type of productTypes" class="filter-option">
          <mat-checkbox
            [id]="'type-' + type"
            [checked]="isProductTypeSelected(type)"
            (change)="toggleProductType(type, $event.checked)"
          >
            {{ type }} <span class="filter-count">({{ getProductTypeCount(type) }})</span>
          </mat-checkbox>
        </div>
      </div>
    </mat-expansion-panel>

    <!-- Size Section -->
    <mat-expansion-panel class="filter-panel">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <mat-icon>straighten</mat-icon>
          Size
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="filter-options">
        <div *ngFor="let size of sizes" class="filter-option">
          <mat-checkbox
            [id]="'size-' + size"
            [checked]="isSizeSelected(size)"
            (change)="toggleSize(size, $event.checked)"
          >
            {{ size }} <span class="filter-count">({{ getSizeCount(size) }})</span>
          </mat-checkbox>
        </div>
      </div>
    </mat-expansion-panel>

    <!-- Category Section -->
    <mat-expansion-panel class="filter-panel">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <mat-icon>category</mat-icon>
          Category
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="filter-options">
        <div *ngFor="let category of categories" class="filter-option">
          <mat-checkbox
            *ngIf="category.id"
            [id]="'category-' + category.id"
            [checked]="isCategorySelected(category.id)"
            (change)="toggleCategory(category.id, $event.checked)"
          >
            {{ category.name }} <span class="filter-count">({{ getCategoryCount(category.id) }})</span>
          </mat-checkbox>
        </div>
      </div>
    </mat-expansion-panel>

    <!-- Colour Section -->
    <mat-expansion-panel class="filter-panel">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <mat-icon>palette</mat-icon>
          Colour
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="filter-options">
        <div *ngFor="let colour of colours" class="filter-option">
          <mat-checkbox
            [id]="'colour-' + colour"
            [checked]="isColourSelected(colour)"
            (change)="toggleColour(colour, $event.checked)"
          >
            {{ colour }} <span class="filter-count">({{ getColourCount(colour) }})</span>
          </mat-checkbox>
        </div>
      </div>
    </mat-expansion-panel>

    <!-- Brand Section -->
    <mat-expansion-panel class="filter-panel">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <mat-icon>business</mat-icon>
          Brand
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="filter-options">
        <div *ngFor="let brand of brands" class="filter-option">
          <mat-checkbox
            [id]="'brand-' + brand.id"
            [checked]="isBrandSelected(brand.name)"
            (change)="toggleBrand(brand.name, $event.checked)"
          >
            {{ brand.name }} <span class="filter-count">({{ getBrandCount(brand.name) }})</span>
          </mat-checkbox>
        </div>
      </div>
    </mat-expansion-panel>

    <!-- Heel Type Section -->
    <mat-expansion-panel class="filter-panel">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <mat-icon>safety_divider</mat-icon>
          Heel Type
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="filter-options">
        <div *ngFor="let heel of heelTypes" class="filter-option">
          <mat-checkbox
            [id]="'heel-' + heel"
            [checked]="isHeelTypeSelected(heel)"
            (change)="toggleHeelType(heel, $event.checked)"
          >
            {{ heel }} <span class="filter-count">({{ getHeelTypeCount(heel) }})</span>
          </mat-checkbox>
        </div>
      </div>
    </mat-expansion-panel>

    <!-- Price Section -->
    <mat-expansion-panel class="filter-panel">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <mat-icon>attach_money</mat-icon>
          Price
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="filter-options">
        <div *ngFor="let price of priceRanges" class="filter-option">
          <mat-checkbox
            [id]="'price-' + price"
            [checked]="isPriceRangeSelected(price)"
            (change)="togglePriceRange(price, $event.checked)"
          >
            {{ price }} <span class="filter-count">({{ getPriceRangeCount(price) }})</span>
          </mat-checkbox>
        </div>
      </div>
    </mat-expansion-panel>

    <!-- Clear Filters Button -->
    <div class="clear-filters-section">
      <button mat-outlined-button color="warn" (click)="clearAllFilters()">
        <mat-icon>clear</mat-icon>
        Clear All Filters
      </button>
    </div>
  </div>
</ng-template>
